// extracted by mini-css-extract-plugin
export default {"wrap":"XnFHmBCgnzj9hZKm6m6e","title":"cJyVEWBFew3l3BoPDjmj","body":"prEC3K9P6BkZfKaaYxCi","section":"qGvtNakCTPZAilJmW9N1"};